export default __webpack_public_path__ + "static/media/lock_3d.543008cd.png";